import {
  AdminPanelSettings,
  CropOriginal,
  Group,
  Person,
} from "@mui/icons-material";
import { ReactNode } from "react";

import { ReportOwnerCategoryEnum } from "@ryde/shared";

export const getReportCategoryIcon = (
  mode: ReportOwnerCategoryEnum | undefined,
): ReactNode => {
  switch (mode) {
    case ReportOwnerCategoryEnum.UserOnly:
      return <Person className="report_owner_category" />;
    case ReportOwnerCategoryEnum.Global:
      return <AdminPanelSettings className="report_owner_category" />;
    case ReportOwnerCategoryEnum.AllUsers:
      return <Group className="report_owner_category" />;
    default:
      return <CropOriginal className="report_owner_category" />;
  }
};
